import { render, staticRenderFns } from "./extendVideo.vue?vue&type=template&id=12fb9ed8&scoped=true&"
import script from "./extendVideo.vue?vue&type=script&lang=js&"
export * from "./extendVideo.vue?vue&type=script&lang=js&"
import style0 from "./extendVideo.vue?vue&type=style&index=0&id=12fb9ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb9ed8",
  null
  
)

export default component.exports